import type { Hotspot } from '../../data/notationHotspots';
import { allHotspots } from '../../data/notationHotspots';
import { SystemGraph } from './vizzes/SystemGraph';
import './CapstoneView.css';

interface CapstoneViewProps {
  selectedHotspot: Hotspot | null;
  exploredIds: Set<string>;
  onSelectHotspot: (id: string) => void;
  onReset: () => void;
  onReplay: () => void;
}

export function CapstoneView({
  selectedHotspot,
  exploredIds,
  onSelectHotspot,
  onReset,
  onReplay
}: CapstoneViewProps) {
  return (
    <div className="capstone-view">
      <div className="capstone-view__graph">
        <SystemGraph
          hotspots={allHotspots}
          selectedId={selectedHotspot?.id || null}
          exploredIds={exploredIds}
          onSelectNode={onSelectHotspot}
        />
      </div>

      <div className="capstone-view__footer">
        <p className="capstone-view__final-line">
          You don't escape notation. <strong>You learn when it's writing you.</strong>
        </p>
        <div className="capstone-view__actions">
          <button className="capstone-view__btn capstone-view__btn--replay" onClick={onReplay}>
            <i className="fas fa-redo"></i> Replay
          </button>
          <button className="capstone-view__btn capstone-view__btn--reset" onClick={onReset}>
            <i className="fas fa-rotate-right"></i> Reset
          </button>
        </div>
      </div>
    </div>
  );
}
